import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  const fadeIn = useFadeIn();
  const benefits = [{
    emoji: '📚',
    title: '4 libros digitales llenos de conexión',
    desc: 'Cada uno pensado para fortalecer la relación entre padres, hijos y pareja.'
  }, {
    emoji: '🎉',
    title: 'Adiós al aburrimiento',
    desc: 'Con actividades divertidas, simples y económicas para disfrutar en cualquier momento.'
  }, {
    emoji: '🗝️',
    title: 'Juegos secretos',
    desc: 'Que te ayudan a descubrir lo que tus hijos sienten, piensan y sueñan, mientras se divierten juntos.'
  }, {
    emoji: '💌',
    title: '30 frases y actividades especiales',
    desc: 'Para que tus hijos nunca olviden cuánto los amás y lo importante que son para vos.'
  }, {
    emoji: '🎁',
    title: 'Bonos exclusivos',
    desc: 'Inspirados en el universo de 100 Citas, con ideas adicionales y retos semanales para mantener viva la conexión familiar.'
  }];
  return <section className="py-16 px-4 bg-gray-50" data-id="element-211">
      <div className="max-w-3xl mx-auto" data-id="element-212">
        <div ref={fadeIn.ref} className={`text-center ${fadeIn.className}`} data-id="element-213">
          <div className="mb-4" data-id="element-214">
            <span className="inline-block bg-red-100 text-red-600 px-4 py-2 rounded-full text-sm font-black uppercase tracking-wider" data-id="element-215">
              💖 La solución
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-12" data-id="element-216">
            💖 Por eso creamos el Pack 100 Citas Familiares
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-217">
            {benefits.map((benefit, idx) => <div key={idx} className="bg-white p-6 rounded-xl shadow-md border-t-4 border-blue-500 text-left" data-id="element-218">
                <div className="text-4xl mb-4" data-id="element-219">{benefit.emoji}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-220">
                  {benefit.title}
                </h3>
                <p className="text-gray-600" data-id="element-221">{benefit.desc}</p>
              </div>)}
          </div>

          <CTAButton text="👉 QUIERO EL PACK 100 CITAS AHORA" data-id="element-222" />
        </div>
      </div>
    </section>;
}